const e=e=>e.reduce(((e,t)=>(t.attributes.forEach((t=>{e.some((e=>e.id===t.id))||e.push(t)})),e)),[]);export{e as mergeHeroFilters};
